<template>
<v-container fluid class="pt-0 mt-0">
			<v-row style="background: #ECEFF1" align="center">
				<v-col cols="12" sm="6" color="blue-grey" class="px-5 primary--text">
					<v-icon class="mr-2">mdi-qrcode-scan</v-icon> /
					<span class="font-weight-bold">{{ $store.state.userModule.user.name }}</span> /
					<span class="font-weight-bold">{{ $store.state.businessModule.business.name }} {{ $store.state.businessModule.business.subtitle }}</span> 
				</v-col>
				<v-col cols="12" sm="6" class="text-right font-weight-bold blue-grey--text">
					<!-- <div v-html="expirationMessage"/> -->
				</v-col>

				<!-- <v-col cols="12" sm="6">
					<div class="text-right">
						<v-btn class="ma-1"  color="primary" @click.stop="editCustomer">
							<v-icon left>mdi-qrcode-scan</v-icon> Ver QR
						</v-btn> 
						<v-btn class="ma-1"  color="primary" :href="`https://pay.menu-qr.net/anual.html`" target="_blank" >
							<v-icon left>mdi-pay</v-icon> SUBSCRIPCIÓN  180€/AÑO
						</v-btn>	
						<v-btn class="ma-1"  color="primary" :href="`https://pay.menu-qr.net/mensual.html`" target="_blank" >
							<v-icon left>mdi-pay</v-icon> SUBSCRIPCIÓN  20€/MES
						</v-btn>		

						<v-btn class="ma-2" color="accent" @click.stop="goCategories">
							<v-icon left>mdi-folder-table</v-icon> Categorías
						</v-btn>
					</div>
				</v-col> -->
		</v-row>
	</v-container>
</template>

<script>
	import moment from 'moment';
	export default {
		name: 'Breadcrumbs',
		methods: {
	
		},
		computed: {
			expirationMessage() {
				
				var now = moment(new Date()).format('YYYY-MM-DD');
				var expiration = moment.unix(this.$store.state.businessModule.business.expiration_date).format('YYYY-MM-DD');;
				var end = moment(expiration);
				var start = moment(new Date()).format('YYYY-MM-DD');
				var days = end.diff(start, 'days')

				if (days < 1 ) {
					return '<span class="red--text">SUSCRIPCIÓN VENCIDA, Contacte administración</span>'
				}

				return `Suscripción. Restan ${days} días`
			}
		}

		
	}
</script>

<style lang="scss" scoped>

</style>